<template>
  <img :src="imageSrc" v-bind="$attrs" />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    imageSrc() {
      return (
        "https://generations.app/cdn-cgi/image/fit=scale-down,f=auto," +
        (this.width > 0 ? `width=${this.width},` : "") +
        "quality=90/" +
        process.env.VUE_APP_APP_DOMAIN +
        this.src
      );
    },
  },
};
</script>

<style scoped></style>
